/* David Pladen — keeps the compare-at price and "Save €…" in step when a
 * colour dot on a product card switches the variant (snippets/dp-price.liquid).
 * assets/dp-product.js already swaps the price itself; this runs after it.
 */

(() => {
  if (window.dpPriceReady) return;
  window.dpPriceReady = true;

  document.addEventListener('click', (event) => {
    const dot = event.target.closest('[data-dp-card] [data-card-variant]');
    if (!dot) return;
    const card = dot.closest('[data-dp-card]');
    window.setTimeout(() => {
      let variants = card.variants;
      if (!variants) {
        try {
          variants = JSON.parse(card.querySelector('script[type="application/json"]').textContent);
        } catch (e) {
          return;
        }
      }
      const v = variants[parseInt(dot.dataset.cardVariant, 10)];
      if (!v) return;
      const sale = Boolean(v.compare);
      card.querySelectorAll('[data-dpp]').forEach((box) => box.classList.toggle('is-sale', sale));
      card.querySelectorAll('[data-dpp-was]').forEach((was) => {
        was.hidden = !sale;
        was.textContent = sale ? v.compare : '';
      });
      card.querySelectorAll('[data-dpp-save]').forEach((save) => {
        save.hidden = !sale;
        save.textContent = sale ? save.dataset.label.replace('[amount]', v.save) : '';
      });
    }, 0);
  });
})();
